import { render, staticRenderFns } from "./InfoCell.vue?vue&type=template&id=62227918&"
import script from "./InfoCell.vue?vue&type=script&lang=js&"
export * from "./InfoCell.vue?vue&type=script&lang=js&"
import style0 from "./InfoCell.vue?vue&type=style&index=0&id=62227918&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports